import {usePage} from "@inertiajs/vue3";
import {computed} from "vue";
import {Role} from "@/types";

const page = usePage()
export const useCurrentRole = computed(() => page.props.role as Role)
